/** Pixel pan so photo marker circles align with the map container center (labels ignored). */
export function questSpotDomMarkerPhotoCenterOffset(mapContainer: HTMLElement): [number, number] | null {
  const cr = mapContainer.getBoundingClientRect();
  if (cr.width <= 0 || cr.height <= 0) return null;
  const mapCx = cr.left + cr.width / 2;
  const mapCy = cr.top + cr.height / 2;
  let minLeft = Infinity;
  let maxRight = -Infinity;
  let minTop = Infinity;
  let maxBottom = -Infinity;
  let count = 0;
  for (const photo of mapContainer.querySelectorAll<HTMLElement>(".quest-spot-dom-marker-photo")) {
    const r = photo.getBoundingClientRect();
    minLeft = Math.min(minLeft, r.left);
    maxRight = Math.max(maxRight, r.right);
    minTop = Math.min(minTop, r.top);
    maxBottom = Math.max(maxBottom, r.bottom);
    count += 1;
  }
  if (count === 0 || !Number.isFinite(minLeft)) return null;
  const groupCx = (minLeft + maxRight) / 2;
  const groupCy = (minTop + maxBottom) / 2;
  return [groupCx - mapCx, groupCy - mapCy];
}

/** Pan so photo circles and title labels stay inside the map (run after photo centering). */
export function questSpotDomMarkerLabelsNudgeOffset(mapContainer: HTMLElement, margin = 4): [number, number] | null {
  const canvas = mapContainer.querySelector("canvas");
  const cr = (canvas ?? mapContainer).getBoundingClientRect();
  if (cr.width <= 0 || cr.height <= 0) return null;
  let minLeft = Infinity;
  let maxRight = -Infinity;
  let minTop = Infinity;
  let maxBottom = -Infinity;
  let any = false;
  for (const marker of mapContainer.querySelectorAll<HTMLElement>(".quest-spot-dom-marker")) {
    for (const el of [
      marker.querySelector<HTMLElement>(".quest-spot-dom-marker-photo"),
      marker.querySelector<HTMLElement>(".quest-spot-dom-marker-title"),
    ]) {
      if (!el) continue;
      const r = el.getBoundingClientRect();
      minLeft = Math.min(minLeft, r.left);
      maxRight = Math.max(maxRight, r.right);
      minTop = Math.min(minTop, r.top);
      maxBottom = Math.max(maxBottom, r.bottom);
      any = true;
    }
  }
  if (!any || !Number.isFinite(minLeft)) return null;
  let panY = 0;
  if (maxBottom > cr.bottom - margin) panY += maxBottom - (cr.bottom - margin);
  if (minTop < cr.top + margin) panY -= cr.top + margin - minTop;
  if (panY === 0) return null;
  return [0, panY];
}

/** @deprecated Use questSpotDomMarkerPhotoCenterOffset */
export function questSpotDomMarkerGroupCenterOffset(mapContainer: HTMLElement): [number, number] | null {
  return questSpotDomMarkerPhotoCenterOffset(mapContainer);
}
